import { render } from "./sms-gateway.vue?vue&type=template&id=71b45a08"
import script from "./sms-gateway.vue?vue&type=script&lang=js"
export * from "./sms-gateway.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__